import { render, staticRenderFns } from "./MarkdownHelpModal.vue?vue&type=template&id=012d687a"
import script from "./MarkdownHelpModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownHelpModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports